import React from "react";

import Navbar from "../components/App/Navbar";
import Footer from "../components/App/Footer";
import Legals from "../components/App/Legals";
import Layout from "../components/App/Layout";
import RegisterPage from "../components/Register/RegisterPage";

const Register = () => {
  return (
    <Layout>
      <Navbar />
      <RegisterPage />
      <Footer />
      <Legals />
    </Layout>
  );
};

export default Register;
